@if (!isRabbitDataLoaded()) {
  <div class="flex flex-col gap-6">
    <p-skeleton height="3.5rem" />
    <p-skeleton height="3.5rem" />
    <div class="flex flex-row gap-4">
      <p-skeleton height="3.5rem" width="10rem" />
      <p-skeleton height="3.5rem" width="10rem" />
    </div>
  </div>
} @else {
  <form [formGroup]="formGroup" class="flex flex-col gap-4" (ngSubmit)="onSubmit()">

    <div class="flex flex-col gap-2">
      <label [for]="formFieldNames.name">
        Name
        <app-required-marker />
      </label>
      <input
          id="name"
          placeholder="Name eingeben"
          type="text"
          pInputText
          [formControlName]="formFieldNames.name" />
    </div>

    <div class="flex flex-row gap-4 items-center">
      <label [for]="formFieldNames.isDisabled">
        Deaktiviert
      </label>
      <p-toggleswitch 
        id="isDisabled"
        [formControlName]="formFieldNames.isDisabled" />
    </div>

    <div class="flex gap-2">
      <p-button type="button" label="Abbrechen" (click)="navigateToOverviewPage()" severity="warn" />
      <p-button type="submit" label="Abschicken" severity="success" [disabled]="formGroup.invalid" />
    </div>

  </form>
}
